import axios from 'axios';

import cfac22 from '../cfac22';

export function getPostById(uId, postId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(

        `${cfac22('API_HOST_V2')}/feedPosts/${postId}`,

        { headers: { 'Full-Url': window.location.href }, withCredentials: true }
      ).
      then((result) => {
        // console.log("RESULT_GetFeedPosts: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_GetFeedPosts: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKE:", error);
      reject(error);
    });
  });
}
